import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
// import UserCard from "../../../ui/userCard";
import { useParams } from 'react-router-dom'
import finalize from '../../dashboardicon/finalize.svg'
import template from '../../dashboardicon/template.svg'
import ballot from '../../dashboardicon/ballot.svg'
import download from '../../dashboardicon/download.svg'
import viewTemplate from '../../dashboardicon/viewTemplate.svg'
import report from '../../dashboardicon/report.svg'
import uploaduser from '../../dashboardicon/uploaduser.svg'
import scanner from '../../dashboardicon/scanner.svg'
import userlist from '../../dashboardicon/userlist.svg'
import dash from '../../dashboardicon/dash.svg'
import ballotEpb from '../../dashboardicon/ballotEpb.svg'
import epbPin from '../../dashboardicon/epbPin.svg'
import marked_list from '../../dashboardicon/marked_list.svg'
import completed from '../../dashboardicon/completedScanning.svg'
import ballotVerification from '../../dashboardicon/ballotVerification.svg'
import back from '../../dashboardicon/back.svg'
import announce from '../../dashboardicon/announce.svg'
import nullify from '../../dashboardicon/nullify.svg'
import slider from '../../dashboardicon/slider.svg'
import { parseJwt } from '../utilities/utils'
import { FaHome, FaInfoCircle, FaBriefcase, FaFileAlt, FaBoxOpen, FaDollarSign, FaQuoteRight, FaPhoneAlt, FaTimesCircle } from "react-icons/fa";

let userDetails = localStorage?.access_token
  ? parseJwt(localStorage?.access_token)
  : null

const stateCode = userDetails?.authorizedStates?.length
  ? userDetails?.authorizedStates['0']
  : ''

const SubLeftMenu = ({ children }) => {
  const { id } = useParams()
  const location = useLocation()
  const { pathname } = location
  const userRole = localStorage.getItem('userrole')
  const navigate = useNavigate()
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const contentRef = useRef(null);
  const tabs = {
    nodal: [
      { name: 'Dashboard', path: '/dashboard', icon: dash },
      { name: 'User List', path: '/users', icon: userlist },
    ],
    cs: [{ name: 'Precounting', path: '/dashboard', icon: scanner }],
    ero: [
      {
        name: 'Finalize Service Voters',
        path: '',
        icon: finalize,
      },
    ],
    deo: [
      { name: 'Dashboard ', path: '/dashboard', icon: dash },
      { name: 'Reports', path: '/report', icon: report }],
    ceo: [
      {name: 'Back ', path: '/dashboard', icon: back},
      { name: 'Ballot Verification Flag ', path: '/enable_disable/ballot_verfication', icon: ballotVerification },
      // { name: 'No Voter Marked ACs ', path: '/enable_disable/no_voter_marked', icon: marked_list },
      { name: 'PreCounting Completed ', path: '/enable_disable/scanning_completed', icon: completed },
    ],
    ceoa: [
      {name: 'Back ', path: '/dashboard', icon: back},
      { name: 'Ballot Verification Flag ', path: '/enable_disable/ballot_verfication', icon: ballotVerification },
      // { name: 'No Voter Marked ACs ', path: '/enable_disable/no_voter_marked', icon: marked_list },
      { name: 'PreCounting Completed ', path: '/enable_disable/scanning_completed', icon: completed },
    ],
    ro: [
      { name: 'Dashboard ', path: '/dashboard', icon: dash },
      { name: 'Transmit e-PB & PIN', path: '/generateEpb', icon: ballot },
      { name: 'Precounting', path: '/precounting', icon: scanner },
      { name: 'Reports', path: '/report', icon: report },
      { name: 'Download', path: '/downloads', icon: download },
    ],
    record: [
      { name: 'Dashboard', path: '/dashboard', icon: dash },
      { name: 'Download e-PB Pin', path: '/epb-pin-download', icon: epbPin },
    ],
    unit: [
      { name: 'Download e-PB Ballot', path: '/epb-ballot-download', icon: ballotEpb },
      // { name: 'Download e-PB Pin', path: '/epb-pin-download', icon: epbPin },
    ],
    eci: [
      { name: 'Dashboard ', path: '/dashboard', icon: dash },
      {
        name: 'Master Templates',
        path: '/view-master-template-ECI',
        icon: template,
      },
      { name: 'Announce Election', path: '/announce-election', icon: announce },
      { name: 'Upload Master', path: '/upload-master', icon: uploaduser },
      { name: 'User List', path: '/users', icon: userlist },
      { name: 'Reports', path: '/report', icon: report },
      {
        name: 'Nullification Request',
        path: '/nullification-requests',
        icon: nullify,
      },

    ],
    epba: [
      { name: 'Dashboard ', path: '/dashboard', icon: dash },
      {
        name: 'Master Templates',
        path: '/view-master-template-ECI',
        icon: template,
      },
      { name: 'Announce Election', path: '/announce-election', icon: announce },
      { name: 'Upload Master', path: '/upload-master', icon: uploaduser },
      { name: 'User List', path: '/users', icon: userlist },
      { name: 'Reports', path: '/report', icon: report },
      {
        name: 'Nullification Request',
        path: '/nullification-requests',
        icon: nullify,
      },

    ],
    epbr: [
      { name: 'Dashboard ', path: '/dashboard', icon: dash },
      {
        name: 'Master Templates',
        path: '/view-master-template-ECI',
        icon: template,
      },
      { name: 'Announce Election', path: '/announce-election', icon: announce },
      { name: 'User List', path: '/users', icon: userlist },
      { name: 'Reports', path: '/report', icon: report },
      {
        name: 'Nullification Request',
        path: '/nullification-requests',
        icon: nullify,
      },

    ],
  }

  const [selectedTab, setSelectedTab] = useState(
    pathname.includes('controlTable/deo')
      ? pathname.split('/')[pathname.split('/').length - 2]
      : pathname.split('/')[pathname.split('/').length - 1]
      ? pathname.split('/')[pathname.split('/').length - 1]
      : '/usermanagement',
  )

  const [show, Setshow] = useState(false)

   useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
        if (window.innerWidth <= 768) {
          setSidebarOpen(false);
        } else {
          setSidebarOpen(true);
        }
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);


     useEffect(()=>{
        if(isMobile ){
       setSidebarOpen(!sidebarOpen)
        }
      },[location.pathname])

  const showNavbar = () => {
    Setshow(!show)
  }

  function mouseEnter() {
    // document.getElementById("right").style.width = "85%";
    console.log("hi")
  }

  return (
   <div className="layout-wrapper">
        {/* Sidebar */}
        <aside
          className={`sidebar ${sidebarOpen ? "open" : ""} ${isMobile ? "mobile" : "desktop"}`}
          style={{
            height: isMobile ? "100vh" : "",
            top: isMobile ? 0 : "0"
          }}
        >
         <div  className={` ${isMobile ? "" : "d-none"}`} style={{margin:"0 2px 8px 0px", textAlign:"right", color:"white"}} onClick={() => setSidebarOpen(!sidebarOpen)} ><FaTimesCircle /></div>
          <nav>
              {tabs[userRole]?.map((item, index) => (
            <Link to={  item.path !== null &&
                        (item.path !== '/eroll_management'
                          ? `/${userRole}${item.path}`
                          : `${item.path}`)} className={pathname.includes(item.path)?"linkItem active":"linkItem"}>  <img
                          src={item.icon}
                          alt="ico"
                          style={{height:20,width:20}}
                        ></img><span>{item.name}</span></Link>
              ))}
          </nav>
        </aside>
   
        {/* Backdrop */}
        {isMobile && sidebarOpen && (
          <div className="backdrop" onClick={() => setSidebarOpen(false)}></div>
        )}
   
        {/* Main content */}
        <div ref={contentRef} className={`content ${sidebarOpen && !isMobile ? "with-sidebar" : ""}`}>
          {/* Hamburger */}
          <button className="hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
            ☰
          </button>
          {children}
        </div>
      </div>
  )
}

export default SubLeftMenu
